import { WalletProviderEnum } from '@dynamic-labs/sdk-api-core';

import type { WalletProviderData } from '../walletProvider.types';

type IsDeeplinkWalletProviderParams = {
  walletProvider: WalletProviderData;
};

/**
 * Returns true if the wallet provider uses the deep link protocol (e.g. Phantom redirect on mobile).
 */
export const isDeeplinkWalletProvider = ({
  walletProvider,
}: IsDeeplinkWalletProviderParams): boolean =>
  walletProvider.walletProviderType === WalletProviderEnum.DeepLink;
